export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const SITE_URL = process.env.NEXT_PUBLIC_URL;
export const ASSETS_ADDRESS = process.env.NEXT_PUBLIC_ASSETS_URL;
export const ASSETS_HOSTNAME = process.env.NEXT_PUBLIC_ASSETS_HOSTNAME;

export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;
export const FACEBOOK_VERIFICATION_ID = process.env.NEXT_FACEBOOK_VERIFICATION_ID;

export const IS_PROD = process.env.NEXT_PUBLIC_IS_PROD === 'true';

export const PREORDER_URL = 'https://buy.stripe.com/4gM14ffDC7WN2Vz7JqfjG01';
